import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import EditarProfessorLayer from "../components/EditarProfessorLayer";
import { useTranslation } from "../i18n/I18nContext";

const EditarProfessorPage = () => {
  const { t } = useTranslation();
  return (
    <MasterLayout>
      <Breadcrumb title={t("professor.breadcrumb.edit")} />
      <EditarProfessorLayer />
    </MasterLayout>
  );
};

export default EditarProfessorPage;
